import { locationSodimac } from "./LocationsCodes/es_sodimac";

const sodimacTranslate = {
  ...locationSodimac,
}

export default sodimacTranslate
